<app-operaciones-usuarios [titulo]="titulo" [usuarios]="usuariosAAceptar" (funcion)="aceptarUsuarios($event)"
    (refresh)="refresh()" botonPrimario="Aceptar" botonSecundario="Rechazar"
    (funcionSecundaria)="rechazarUsuarios($event)">
</app-operaciones-usuarios>